import React, { Component } from "react"
import PropTypes from "prop-types"
import ReactModal from "react-modal"
import { Translate } from "react-localize-redux"

const VOUCHER_BUNDLE_ERROR_CODE = {
	EMAIL_NOT_VALID: "VB_01",
	VOUCHER_BUNDLE_EXPIRED: "VB_02",
}
class BaseModalVoucherBundle extends Component {
	constructor(props) {
		super(props)

		this.handleCancelClick = this.handleCancelClick.bind(this)
		this.handleConfirmClick = this.handleConfirmClick.bind(this)
		this.handleAfterOpenModal = this.handleAfterOpenModal.bind(this)
	}

	componentWillMount() {
		ReactModal.setAppElement("#root")
	}

	handleCancelClick() {
		const { onCancelClick } = this.props
		onCancelClick && onCancelClick()
	}

	handleConfirmClick() {
		const { onConfirmClick } = this.props
		onConfirmClick && onConfirmClick()
	}

	handleAfterOpenModal() {
		const { onAfterOpenModal } = this.props
		onAfterOpenModal && onAfterOpenModal()
	}

	render() {
		const {
			showModal,
			title,
			message,
			isOpen,
			confirmButtonText,
			cancelButtonText,
			...props
		} = this.props

		return (
			<Translate>
				{(translate, activeLanguage) => (
					<ReactModal
						isOpen={isOpen}
						onAfterOpen={this.handleAfterOpenModal}
						onRequestClose={this.handleCancelClick}
						{...props}>
						<div className="modal-header">
							<div
								className="modal-header-title"
								style={{
									fontWeight: 600,
									lineHeight: "22px",
									fontSize: "18px",
									color: "rgba(0, 0, 0, 0.87)",
								}}>
								{(this.props.message &&
									this.props.message.data &&
									this.props.message.data.title) ||
									translate("modal.title._message")}
							</div>
						</div>
						<div
							className="modal-body pt-0"
							style={{
								fontWeight: "400",
								lineHeight: "14px",
								fontSize: "12px",
								color: "rgba(0, 0, 0, 0.58)",
							}}>
							{this.props.message &&
								this.props.message.data &&
								this.props.message.data.message}
						</div>

						{this.props.message.data.errorCode ===
						VOUCHER_BUNDLE_ERROR_CODE.VOUCHER_BUNDLE_EXPIRED ? (
							<div>
								<a href="tel:02873067676">
									<div
										style={{
											paddingLeft: "20px",
											paddingRight: "20px",
											marginBottom: "16px",
										}}>
										<button
											className="btn btn-primary btn-small btn-modal-ok btn-block w-100"
											// onClick={this.handleConfirmClick}
											style={{
												display: "block",
											}}>
											{/* {confirmButtonText || translate("modal.button._ok")} */}
											{translate(
												"voucherBundle.content.call.hotline"
											)}
										</button>
									</div>
								</a>
								<div
									style={{
										paddingLeft: "20px",
										paddingRight: "20px",
										marginBottom: "20px",
									}}>
									<button
										type="button"
										// className="btn btn-outline-secondary btn-small w-100"
										className="btn btn-small w-100"
										onClick={this.handleCancelClick}
										style={{
											display: "block",
											color: "rgba(0, 0, 0, 0.87)",
											border: "1px solid rgba(0, 0, 0, 0.87)",
											backgroundColor: "white",
										}}>
										{cancelButtonText ||
											translate("modal.button._cancel")}
									</button>
								</div>
							</div>
						) : (
							<div
								style={{
									paddingLeft: "20px",
									paddingRight: "20px",
									marginBottom: "20px",
								}}>
								<button
									type="button"
									className="btn btn-primary btn-small btn-modal-ok btn-block w-100"
									// className="btn btn-outline-dark btn-small"
									onClick={this.handleCancelClick}
									style={{
										display: "block",
									}}>
									{cancelButtonText || translate("modal.button._ok")}
								</button>
							</div>
						)}

						{/* <div className="modal-footer"></div> */}
					</ReactModal>
				)}
			</Translate>
		)
	}
}

BaseModalVoucherBundle.propTypes = {
	title: PropTypes.string,
	isOpen: PropTypes.bool.isRequired,
	hideModal: PropTypes.func.isRequired,
	children: PropTypes.any,
	onCancelClick: PropTypes.func.isRequired,
	onConfirmClick: PropTypes.func.isRequired,
	onAfterOpenModal: PropTypes.func,
	confirmButtonText: PropTypes.string,
	cancelButtonText: PropTypes.string,
}

export default BaseModalVoucherBundle



// WEBPACK FOOTER //
// ./src/views/components/modal/BaseModalVoucherBundle.js